import { supabase } from "../supabase";

// Refetches likes/downloads/comment_count for a page's currently-loaded
// design ids on an interval, instead of an unfiltered realtime listener
// broadcasting every design's change to every connected client regardless
// of whether it's even on screen — that scales as connected users ×
// app-wide activity, whereas this (each client reading its own small set)
// scales with connected users alone. Paused while the tab is hidden.
export function subscribeToStatsPolling(getIds, onUpdate, intervalMs = 30000) {
  let stopped = false;

  async function poll() {
    if (stopped || document.visibilityState !== "visible") return;
    const ids = getIds();
    if (ids.length === 0) return;

    const { data, error } = await supabase
      .from("designs")
      .select("id, likes, downloads, comment_count")
      .in("id", ids);

    if (error) {
      console.log("STATS POLL ERROR:", error);
      return;
    }
    if (!stopped && data) onUpdate(data);
  }

  const timer = setInterval(poll, intervalMs);
  return () => {
    stopped = true;
    clearInterval(timer);
  };
}
